import { useState } from "react";
import SchedulerModal from "../../components/auth/SchedulerModal";

const RegistrationBtnGroup = ({buttons = []}) => {
  const [modalUrl, setModalUrl] = useState("");
  const [modalType, setModalType] = useState("");

  const handleScheduleClick = (rule) => {
    const url =
      rule === "pay"
        ? process.env.REACT_APP_ACUITY_PREMIUM_CLASS_URL
        : process.env.REACT_APP_ACUITY_FREE_CLASS_URL;

    if (!url || url === "#") return;
    setModalUrl(url);
    setModalType(rule);
  };

  const closeModal = () => {
    setModalUrl("");
    setModalType("");
  };

  return (
    <>
        <div className ="container classes-view-main">
            <div className="registration-btn-group-section">
                <div className="group-section">
                    {buttons.map((btn, i) => {
                        const rule = btn.rule || "pay";
                        const itemClass =
                            rule === "pay"
                            ? "item today-btn"
                            : rule === "free"
                            ? "item week-btn"
                            : "item";

                    return (
                        <div key={i} className={itemClass}>
                        <button
                            type="button"
                            className="footer-btn font-amaticsc-bold"
                            onClick={() => handleScheduleClick(rule)}
                        >
                            {btn.title}
                            {btn.titleJP && (
                            <span className="btn-text font-kleeone">{btn.titleJP}</span>
                            )}
                        </button>
                        </div>
                    );
                    })}
                </div>
            </div>

            <SchedulerModal url={modalUrl} onClose={closeModal} type={modalType} />
        </div>
    </>
  )
}

export default RegistrationBtnGroup;